
import CardActions from '@material-ui/core/CardActions';
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import _ from 'lodash';
import { CreateButton, DeleteButton, number, required, ShowButton,TextField,FunctionField } from 'react-admin';


export const montant9Chiffres = (value, allValues) => {

    if(value && value>=1000000000){
      return 'Ce montant est trop grand !';
    }

    return null;
}

export const nombreNagatif = (value, allValues) => {

  if(value && value<0){
    return 'Ce montant est trop grand !';
  }

  return null;
}

export const validateMontant = [number('Le montant doit être un nombre'),required(),montant9Chiffres];

export const json=(response)=>{
  return response.json()
}


export const reductionValidation = (min, message = 'Vous ne pouvez pas appliquer une reduction de plus de 50% !') => 
    value => value && value < min ? message : undefined;

export const  telValidation = (value, allValues) => {
  if (!allValues.tel_exp1 && !allValues.tel_dest1) {
      return 'Il faut saisir au moins un numéro expediteur ou destinateur';
  }

  return null;
}

export const  dateArriveValidation = (value, allValues) => {
  if (!allValues.dateArrive || !allValues.dateDepart) {
      return "Les dates de départ et d'arrivée sont obligatoires";
  }

  if (allValues.dateArrive < allValues.dateDepart) {
    return "La date d'arrivée ne peut pas être inférieur à la date départ !!";
}

  return null;
}

export const telValidationExp = (value, allValues) => {
  if(value && !value.startsWith('0')) return 'Le téléphone expéditaire doit commencer par un 0'; 

  if(!allValues.tel_exp1 || value && value.length!==10){
    return 'Le téléphone expéditeur doit contenir 10 chiffres';
    }
    if(value && isNaN(Number(value))){
      return 'Le téléphone expéditeur ne doit contenir que des chiffres';
    }
    return null;
}

export const telValidationDest = (value, allValues) => {

    if(value && !value.startsWith('6')) return 'Le téléphone destinateur doit commencer par un 6'; 

    if(!allValues.tel_dest1 || value && value.length!==9 ){
      return 'Le téléphone destinateur doit contenir 9 chiffres';
    }
    if(value && isNaN(Number(value))){
      return 'Le téléphone destinateur ne doit contenir que des chiffres';
    }
    return null;
}


export const valideTotal = (value, allValues,props) => {

  if(allValues.lines_colis){
    var i=props.name.replaceAll("lines_colis[",'').replaceAll("].total_line",'');
    
    if(allValues.lines_colis[i] && allValues.lines_colis[i].total_line && Math.trunc(allValues.lines_colis[i].poids*allValues.lines_colis[i].prix_unitaire)<Math.trunc(allValues.lines_colis[i].total_line)){
      return 'Le total ne peut pas être supérieur à la poids*prix_unitaire';
    }
  }



  return null;
}


export const frais=[
    { id: '0.0',    name: '0%' },
    { id: '0.01', name: '1%' },
    { id: '0.02', name: '2%' },
    { id: '0.03', name: '3%' },
    { id: '0.04', name: '4%' },
    { id: '0.05', name: '5%' },
    { id: '0.06', name: '6%' },
    { id: '0.07', name: '7%' },
    { id: '0.08', name: '8%' }
];

export const devise=[
    { id: 'auto', name: 'Euro => FG' },
    { id: 'FG', name: 'FG => Euro' },
    { id: 'EUCFA', name: 'Euro => CFA' },
    { id: 'CFA', name: 'CFA => Euro' },
    { id: 'EU', name: 'Euro => Euro' }
];


export const deviseFiltre=[
  { id: 'TOUS', name: 'TOUS' },
  { id: 'FG', name: 'FG' },
  { id: 'EU', name: 'Euro' },
  { id: 'USD', name: 'USD' }
];

export const devises=[
  { id: 'FG', name: 'FG' },
  { id: 'EU', name: 'Euro' },
  { id: 'USD', name: 'USD' }
];

export const typeAgence=[
  { id: 'gui', name: 'Guinée' },
  { id: 'fr', name: 'France' },
  { id: 'afr', name: 'Afrique' },
  { id: 'man', name: 'Manager' }

];


export const statusCampagne=[
  { id: 'PROC', name: 'Prochaine' },
  { id: 'ATTENTE', name: 'En attente' },
  { id: 'FERMER', name: 'Fermer' },
  { id: 'ENROUTE', name: 'En route' },
  { id: 'ARRIVE', name: 'Arrivé' },
  { id: 'FIN', name: 'Fin distribution' }
];

export const statusCampagneCrea=[
  { id: 'ATTENTE', name: 'En attente' },
  { id: 'PROC', name: 'Prochaine' }
];


export const getDevise = (envoie,retrait) => {

    if(envoie==='EU' && retrait==='FG') return 'auto';
    if(envoie==='EU' && retrait==='CFA') return 'EUCFA';
    if(envoie==='FG' && retrait==='EU') return 'FG';
    if(envoie==='CFA' && retrait==='EU') return 'CFA';
    if(envoie==='EU' && retrait==='EU') return 'EU';
    if(envoie==='FG' && retrait==='FG') return 'FG';
    if(envoie==='CFA' && retrait==='CFA') return 'CFA';

}

export const suppSpaceStyle={
        marginTop:0,
        marginBottom:0,
        paddingTop:0,
        paddingBottom:0
};

export const hide={
    display:'none'
};



export const get_ag_dest_name=(id,list_ag_dest)=>{
    for(var i=0;i<list_ag_dest.length;i++) if(list_ag_dest[i].id === id) return list_ag_dest[i].name;
    return '';
}

export const get_ag_type=(id,list_ag_dest)=>{
    for(var i=0;i<list_ag_dest.length;i++) if(list_ag_dest[i].id === id) return list_ag_dest[i].type_agence;
    return '';
}

export const round = (num,places) => {
  return +(Math.round(num + "e+" + places)  + "e-" + places);
}

export const bleu = {
    borderLeftColor: blue[500],
    borderLeftWidth: 10,
    borderLeftStyle: 'solid'
}


export const style_green = {color: green[700] }
export const style_bleu = {color: blue[700] }
export const style_red = {color: red[700] }

export const filterAgAfriqueGetDeviseEnvoie = (trans,trans_devise_show,list_ag_dest) => {

    var l_ag_dest_by_devise=[];


  if(trans.trans_devise_show){
    var selectedDevise=trans_devise_show;

    if(selectedDevise ==='CFA' || selectedDevise ==='EUCFA') {
      trans_devise_show = selectedDevise ==='CFA' ? 'CFA' : 'EU';

      for(var i=0;i<list_ag_dest.length;i++){
         if(list_ag_dest[i].type_agence==='5') l_ag_dest_by_devise.push(list_ag_dest[i]);
      }
         return {trans_devise_envoie:trans_devise_show,l_ag_dest_by_devise:l_ag_dest_by_devise};
    } 

    if(selectedDevise ==='FG'  || selectedDevise ==='auto') {
        trans_devise_show = selectedDevise ==='FG' ? 'FG' : 'EU';
        l_ag_dest_by_devise=list_ag_dest.filter(item=>item.type_agence!=='5');
        return {trans_devise_envoie:trans_devise_show,l_ag_dest_by_devise:l_ag_dest_by_devise};
    } 

    if(selectedDevise ==='EU') {
      trans_devise_show = 'EU';
      l_ag_dest_by_devise=list_ag_dest;
      return {trans_devise_envoie:trans_devise_show,l_ag_dest_by_devise:l_ag_dest_by_devise};
    } 
   return null;
  }

}


export const replaceDeviseByVide = (montant) =>{
   return montant===null ? '' : montant.replace('FG','').replace('EU','').replace('CFA','').trim();
}

const cardActionEditStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
}


export const PostEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionEditStyle}>
        <ShowButton basePath={basePath} record={data} />
        <CreateButton basePath={basePath} />
        <DeleteButton title={'Supprimer'} basePath={basePath} record={data} resource={resource} />
    </CardActions>
);

export const PostEditActionsDelete = ({ basePath, data, resource }) => (
    <CardActions style={cardActionEditStyle}>
        <DeleteButton title={'Supprimer'} basePath={basePath} record={data} resource={resource} />
    </CardActions>
);

export const toolbarStyles = {
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}


export const filterDeviseByUserRole = (roles,typeAfrique,formData,deviseSimple)=>{
  return roles==='ag_exp' ? deviseSimple.filter(item => item.id === 'EU'):
                    (formData.type_agence=== 'fr') ? deviseSimple.filter(item => item.id === 'EU') :
                    (formData.type_agence=== 'man' && typeAfrique==='5') ? deviseSimple.filter(item => item.id !== 'FG'): 
                    (formData.type_agence=== 'man' && typeAfrique !=='5') ? deviseSimple.filter(item => item.id !== 'CFA'):
                    formData.type_agence=== 'afr' ? deviseSimple.filter(item => item.id !== 'FG') : 
                    formData.type_agence=== 'gui' ? deviseSimple.filter(item => item.id !== 'CFA') : deviseSimple;
}


export const getNumberFromFormattedNumber=(FomattedNumber)=>{
  var number =  FomattedNumber.split('.').join('').replace(',','.');
  return number.split(' ').join('').replace(',','.');
}

export const formatPhone=(phone)=>{
  if(phone && phone.startsWith('+33') ) return  "0"+phone.substring(3);
  if(phone && phone.startsWith('+224') ) return  phone.substring(4);
  return phone;
};

export const formatPhoneInternational=(phone)=>{
  if(phone && phone.startsWith('0') ) return  "+33"+phone.substring(1);
  if(phone && phone.startsWith('6') ) return  "+224"+phone;
  return phone;
};


export const formatDate=(date)=>{
  //console.log(date);
  return date ? date.replace("T"," ").substring(0,19):"";
};

export const valideMontantSaisi = (total_general,montantSaisi) => {

  if(montantSaisi>total_general) return 'Le montant saisi ne peut pas être supérieur au montant de la facture !'; 
  //if(!montantSaisi) return "Il vous faut saisir un montant avant de cliquer sur OK";
  return false;
}

//roles==='ag_exp' ? deviseSimple.filter(item => item.id === 'EU'):(formData.type_agence=== 'fr' ) ? deviseSimple.filter(item => item.id === 'EU'): formData.type_agence=== 'afr' ? deviseSimple.filter(item => item.id !== 'FG') : formData.type_agence=== 'gui' ? deviseSimple.filter(item => item.id !== 'CFA') : deviseSimple

export const fret_handleTypeFret=(adresses,type,typeDept,typeArr,adrDeptId,adrArrId)=>{
  var list_adr_dep=null;
  var list_adr_arr=null;
  var defaultValues=null;

  list_adr_dep=adresses.filter(item=>item.type===typeDept);
  list_adr_arr=adresses.filter(item=>item.type===typeArr);

  list_adr_dep.forEach((item, index) => {
      list_adr_dep[index] = { id: item.id, name: item.libele };
  })

  list_adr_arr.forEach((item, index) => {
      list_adr_arr[index] = { id: item.id, name: item.libele };
  })
  defaultValues={type:type,adrDeptId:adrDeptId,adrArrId:adrArrId};

  return {list_adr_dep:list_adr_dep,list_adr_arr:list_adr_arr,defaultValues:defaultValues};
}


export const formatAdresse = (adresse) => {
  if(!adresse) return null;
  var adr='';
  if(adresse.libele) adr=adresse.libele;
  if(adresse.numeroRue) adr+= ' '+adresse.numeroRue;
  if(adresse.nomRue) adr+= ' '+adresse.nomRue;
  if(adresse.codePostale) adr+= ' '+adresse.codePostale;
  if(adresse.commune) adr+= ' '+adresse.commune;
  return adr;
  
}

export const get_total_general=(formData)=>{
  var total=0;
  if(formData && formData.lines_colis && formData.lines_colis.length>0){
      formData.lines_colis.forEach((item, index) => {
          if(item && item.poids && item.prix_unitaire) {
              total=item.total_line ? total+item.total_line : total + item.poids * item.prix_unitaire;
          }
          
      })

    }
    if(formData && formData.gratuit_excep){
      return 0;
    }

    return formData && formData.frais_enlevement ? formData.frais_enlevement+total:total;
}

export const get_total_general_vehicule=(formData)=>{
  var total=0;
  if(formData && formData.lines_colis && formData.lines_colis.length>0){
      formData.lines_colis.forEach((item, index) => {
          if(item && item.prix_unitaire) {
              total=item.total_line ? total+item.total_line : total + item.prix_unitaire;
          }
          
      })

    }
    if(formData && formData.gratuit_excep){
      return 0;
    }

    return formData && formData.frais_enlevement ? formData.frais_enlevement+total:total;
}
export const getListCampagnes=(type)=>{
  var list_camps=[];
  var camps =JSON.parse(localStorage.getItem('camps'));

  if(camps){
      camps=camps.filter(item=>item.type===type && item.status==='ATTENTE');
      camps=_.orderBy(camps, ['id'],['desc']);
      camps.forEach((item, index) => {
          list_camps[index] = { id: item.id, name: item.code };
      })
  } 
  return list_camps;
}


const phoneHref=(tel)=>{
  return  "tel:"+formatPhoneInternational(tel);
}

export const PhoneExpField = ({source, record}) => (

  <a style={{ color: 'purple' }} href={phoneHref(record  && record.tel_exp? record.tel_exp:"")}>{record && record.tel_exp ? (record && record.client_exp ? record.client_exp +' '+record.tel_exp:record.tel_exp):record.client_exp}</a>
);

export const PhoneDestField = ({source, record}) => (

  <a style={{ color: 'purple' }} href={phoneHref(record && record.tel_dest ? record.tel_dest:"")}>{record && record.tel_dest ?  (record && record.client_dest ? record.client_dest +' '+record.tel_dest:record.tel_dest):record.client_dest }</a>
);

export async function fetchMessagesJSON(url,method,body) {
  var response =null;
  if(body){
    response = await fetch(url, 
      { 
        method: method,
        headers: {
        "Content-type": "application/json; charset=UTF-8",
        "Authorization": "Bearer "+ localStorage.getItem('token')
        },
        body:body
      });
  }else{
    response = await fetch(url, { method:method,
      headers: {
      "Content-type": "application/json; charset=UTF-8",
      "Authorization": "Bearer "+ localStorage.getItem('token')
      }
    });
  }
  const messages = await response.json();
  return messages;
}

export const modePayementFiltre=[
  {id:'tous',name:'Tous'},
  {id:'espece',name:'ESPECE'},
  {id:'carte',name:'CARTE'},
  {id:'cheque',name:'CHEQUE'},
  {id:'virmen',name:'VIR'}
];


export const modePayement=[
  {id:'espece',name:'ESPECE'},
  {id:'carte',name:'CARTE'},
  {id:'cheque',name:'CHEQUE'},
  {id:'virmen',name:'VIR'}
];



export const typeCampagne=[
  { id: 'AERIEN', name: 'FAP : Aérien' },
  { id: 'MARITIME', name: 'FMP : Maritime' },
  { id: 'AERIEN_DE_CNKRY', name: 'FAC : Aérien conakry' },
  { id: 'VEHICULE', name: 'VEH : VEHICULE ' },
];

export const isManager=(roles,user_id)=>{
  if(roles!=null && roles.includes('ROLE_MANAGER') ){
      return user_id!==null && user_id!==0;
  }
  //console.log(user_id);
  return false;
}

export const has_role=(roles,role)=>{
  return roles!==undefined && roles!==null && roles.includes(role);
}


export const isSelectable=(roles,user_id,camp_type)=>{
  if(roles!==undefined  && roles!==null && roles.includes('ROLE_MANAGER') ){
      return user_id!==null && user_id!==0;
  }

  if(user_id!=null && user_id!==0) return false;

  if((has_role(roles,'ROLE_AG_EXP_AERIEN_FR') && camp_type==='AERIEN') ||
    (has_role(roles,'ROLE_AG_EXP_MARITIME_FR') && camp_type==='MARITIME') ||
    (has_role(roles,'ROLE_AG_EXP_AERIEN_GUI') && camp_type==='AERIEN_DE_CNKRY')) return true;

  //console.log(user_id);
  return false;
}


export const getAgentListByRole=(role,roleUserList)=>{
  roleUserList= roleUserList ? roleUserList.filter(item=>item.role===role):[];
  return roleUserList && roleUserList.length>0? _.orderBy(roleUserList[0].roleUsers, ['name'],['ASC']):[];
}

export const getAgentRole=(roleUserList)=>{
  const roles= roleUserList ? roleUserList.map(function(key,value){
    return {id:key.role,name:key.libelle};
  }):[];
  return  _.orderBy(roles, ['name'],['desc']);
}

export const status=[
    { id: 'TOUS', name: 'Tous' },
    { id: 'ATTENTE', name: 'Attente de validation' },
    { id: 'OK', name: 'Confirmer' },
    { id: 'ANNULER', name: 'Annuler' },
];


export const MontantField = ({source, record}) => (
  <p >{new Intl.NumberFormat().format(record.montant)+' '+record.devise}</p>
);



export const differentDeZero = (value) => {
  //console.log(value);
  if(value === 0 || value === '0') return 'Ce champ ne peut pas être égal à zero'; 
  return false;
}

export const infOuEgalA100 = (value) => {
  if(value >100) return 'La quantité ne peut pas être supérieur à 100!'; 
  return false;
}

export const campType = (type) => {
  var campType='Inconnu';
  type=type?type.toUpperCase():'';
  switch (type) {
    case 'AERIEN':
      campType='Aérien';
      break;
    case 'MARITIME':
      campType='Maritime';
      break;
    case 'AERIEN_DE_CNKRY':
      campType='Conakry aérien';
      break;
    case 'VEHICULE':
        campType='Véhicule';
        break;
    default:
      break;
  }
  return campType;
}

export const  equalNewPassWords = (value, allValues) => {
  if (allValues.newPassword!==allValues.newPassword1) {
      return 'Le nouveau de passe saisi dans les 2 champs sont différents !';
  }
  return false;
}


export const fetchCampagne=(type,setListCamps,notify)=>{
  fetch(process.env.REACT_APP_URL+'/camp/getCampagneForFilters?nb=10&resource='+type, 
  {   method: 'GET',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=UTF-8',
          "Authorization": "Bearer "+ localStorage.getItem('token')
      }
  }
  ).then(json)
  .then((data) => {
      setListCamps(data);
  }).catch((e) => {
      notify("Erreur lors de la récuperation des campagnes pour le filtre !", 'warning')
  });
}

export const createAutorisation=(permissions,resource)=>{

  if ((resource==='aerien' && (has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI'))) || 
     (resource==='maritime' && (has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI'))) ||
     (resource==='vehicule' && (has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI'))) ||
     (resource==='aerien_de_cnkry' && (has_role(permissions,'ROLE_MANAGER') || has_role(permissions,'ROLE_AG_EXP_AERIEN_FR') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR') ))
     ){
       return false
  }else if(has_role(permissions,'ROLE_AG_EXP_AERIEN_FR')  || has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI') || has_role(permissions,'ROLE_AG_EXP_MARITIME_FR') ){
    return true;
  }

  return false;
}


export const isExpGui=(permissions)=>{
  return  has_role(permissions,'ROLE_AG_EXP_AERIEN_GUI');
}

export const getCampKindFromCampCode=(camp_code)=>{
  var campType='Inconnu';
  camp_code=camp_code?camp_code:'';
  switch (camp_code.substr(0,7)) {
    case 'CAMP-FAP':
      campType='aerien';
      break;
    case 'CAMP-FMP':
      campType='maritime';
      break;
    case 'CAMP-FAC':
      campType='aerien_de_cnkry';
      break;
    case 'CAMP-VEH':
        campType='vehicule';
        break;
    default:
      break;
  }
  return campType;
}

export const SearchResultField = ({source, record}) => (
    <>
        Code : <TextField source="code" style={{ color: 'blue' }}/>
        <br/>
        <TextField source="creator" />
        <br/>
        Status facture : <span><FunctionField render={record =>formatStatus(record.status) } /></span>
        <br/>
        Total encaissé :  <TextField source="total_encaisse"  /> €
        <br/>
        Reste à payer : <TextField source="reste_a_payer"  /> €
        <br/>
        Tel expéditaire : <a style={{ color: 'purple' }} href={phoneHref(record  && record.tel_exp? record.tel_exp:"")}>{record && record.tel_exp ? (record.client_exp ? record.client_exp +' '+record.tel_exp:record.tel_exp):record.client_exp}</a>
        <br/>
        Tel destinataire : <a style={{ color: 'purple' }} href={phoneHref(record && record.tel_dest ? record.tel_dest:"")}>{record && record.tel_dest ?  (record.client_dest ? record.client_dest +' '+record.tel_dest:record.tel_dest):record.client_dest }</a>

        <TextField source="message"  multiline  component="pre" />

    </>
  );


  const formatStatus=(status)=>{
    var formattedStatus='Inconnu';
    
    switch (status) {
      case 'ATTENTE':
        formattedStatus='En attente de validation';
        break;
      case 'APPV':
          formattedStatus='Validé';
          break;
        case 'PAYER':
          formattedStatus='Payé';
          break;
      case 'Non payé':
        formattedStatus='Non payé';
          break;
      case 'ANNULER':
          formattedStatus='Annulé';
          break;
      case 'DEVIS':
         formattedStatus='Dévis';
          break;
      default:
        break;
    }
    return formattedStatus;
  }


  export const getBaseUrlCheckAdmin=(permissions,record_id,method,adminBase,camp_type)=>{
    adminBase=adminBase.toLowerCase();
    camp_type=camp_type.toLowerCase();
    let baseUrl='';
    if(method==='show') {
      baseUrl=has_role(permissions,'ROLE_MANAGER') ? adminBase : camp_type;
      return baseUrl+'/'+record_id+'/'+method;
    }
    else baseUrl=has_role(permissions,'ROLE_MANAGER') ? '/'+adminBase+'/'+record_id+'/edit?resource='+camp_type :'';
    return baseUrl;
  }

  export const getUserRoles=(usersWithRoles,user_rec_id)=>{
    //let response;
    for (var i = 0; i < usersWithRoles.length; i++) {
      
      for (var j = 0; j < usersWithRoles[i].roleUsers.length; j++) {
        if(usersWithRoles[i].roleUsers[j].id===user_rec_id) return usersWithRoles[i].role;
      }
    }
    return null;
  } 

  export const getAdr=(type)=>{
    var ret=null;
    var adresses =JSON.parse(localStorage.getItem('adrCampagnes'));
    if(adresses && type==='MARITIME'){
        ret =fret_handleTypeFret(adresses,type,'DEP_MARITIME','ARR_MARITIME',2,13);
        return {list_adr_dep:ret.list_adr_dep,list_adr_arr:ret.list_adr_arr,defaultValues:ret.defaultValues}
    }

    if(adresses && type==='AERIEN'){
        ret =fret_handleTypeFret(adresses,type,'DEP_AERIEN','ARR_AERIEN',3,10);
        return {list_adr_dep:ret.list_adr_dep,list_adr_arr:ret.list_adr_arr,defaultValues:ret.defaultValues}

    }

    if(adresses && type==='AERIEN_DE_CNKRY'){
        ret =fret_handleTypeFret(adresses,type,'DEP_AERIEN_CNKRY','ARR_AERIEN_CNKRY',9,5);
        return {list_adr_dep:ret.list_adr_dep,list_adr_arr:ret.list_adr_arr,defaultValues:ret.defaultValues}

    }

    if(adresses && type==='VEHICULE'){
        ret =fret_handleTypeFret(adresses,type,'DEP_VEHICULE','ARR_VEHICULE',77,78);
        return {list_adr_dep:ret.list_adr_dep,list_adr_arr:ret.list_adr_arr,defaultValues:ret.defaultValues}

    }
    return  {list_adr_dep:null,list_adr_arr:null,defaultValues:null}
  }